import { AllCountries } from './AllCountries'

export const getCountryDataBasedOnDialCode = (argDialCode: string) => {
   // TODO: need to revert these changes once backend gives + with dial code
   const dialCode = argDialCode.trim()
   const withOrWithoutPlusPrefix = dialCode.startsWith('+')
      ? dialCode.slice(1)
      : `+${dialCode}`

   const countryList = AllCountries.getCountries()
   const matchedCountries: Array<any> = countryList.filter(each => {
      const originalVariantCheck = each.dialCode === dialCode
      const plusPrefixVariantCheck = each.dialCode === withOrWithoutPlusPrefix

      return originalVariantCheck || plusPrefixVariantCheck
   })

   return matchedCountries
}

export const getDialCode = (countryCode: string) => {
   const countryList = AllCountries.getCountries()
   const countryArray = countryList.find(
      countryArray => countryArray?.iso2 === countryCode.toLowerCase()
   )

   return countryArray ? `+${countryArray.dialCode}` : ''
}

export const defaultCountryISO2 = 'IN'
export const defaultCountryCode = '91'
